module.exports = "/images/Widgets_2.svg?8dea142ce16b2c578d8f4944b8037191";